import { guidEmpty } from "../../../utils/guid-empty";
import { EnumTipoPessoaContato } from "../../enums/enum-tipo-pessoa-contato";

export class PessoaContatosModel {
  constructor(
    public id: string = guidEmpty(),
    public pessoaId: string = guidEmpty(),
    public tipo: EnumTipoPessoaContato = EnumTipoPessoaContato.EMAIL,
    public valor: string = "",
    public responsavel: string = "",
  ) { }
}
